import TemplateView from "../../../TemplateView";
import UserTime from "../../../user_time";
import _ from "underscore";
import {Feature, isEnabled} from "../../../features/index";
import SummaryRecord from "./SummaryRecord";
import messageResource from "../../../messageResource";

export default class Header extends TemplateView {

    constructor($containerEl) {
        super($containerEl);

        this.state = {
            totalTime: null,
            estimatedTime: null
        }

        this.onStatePropertyChanged("totalTime", (totalTime) => {
            this.totalRecord.setValue(totalTime);
        })

        this.onStatePropertyChanged("estimatedTime", (estimatedTime) => {
            const showEst = _.isNumber(estimatedTime) && isEnabled(Feature.EST);
            if (showEst) {
                this.$estimatedValue.text(UserTime.formatTimeWithDigitSeparator(estimatedTime));
            }
            this.$ofEstimated.toggleClass('displayed', showEst);
        })
    }

    templateHtml() {
        return "<div class='totalSpentHeader sectionHeader'/>" +
               "<span class='ofEstimated'><%=of%>  <span class='estimatedValue'/></span>";
    }

    messageKeys() {
        return {
            of: 'common.of',
        }
    }

    afterRender() {
        this.totalRecord = new SummaryRecord(this.$containerEl.find('.totalSpentHeader'),
            messageResource.getMessage('task.edit_panel.total_spent') + ':', false).init();
        this.$estimatedValue = this.find(".estimatedValue");
        this.$ofEstimated = this.$containerEl.find(".ofEstimated");
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/task/reportedTime/Header.js